import { StructuredData } from './StructuredData';

const webPageSchema = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  "name": "Candidate Work Style Assessment for Better Team Fit",
  "description": "Understand how candidates prefer to work and collaborate — using structured, job-relevant insights. Designed to support hiring decisions, not replace human judgment.",
  "url": "https://beatview.ai/work-style-assessment",
  "isPartOf": {
    "@type": "WebSite",
    "name": "Beatview",
    "url": "https://beatview.ai"
  },
  "publisher": {
    "@type": "Organization",
    "name": "Beatview",
    "url": "https://beatview.ai"
  }
};

const breadcrumbSchema = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": [
    {
      "@type": "ListItem",
      "position": 1,
      "name": "Home",
      "item": "https://beatview.ai"
    },
    {
      "@type": "ListItem",
      "position": 2,
      "name": "Work Style Assessment",
      "item": "https://beatview.ai/work-style-assessment"
    }
  ]
};

const softwareApplicationSchema = {
  "@context": "https://schema.org",
  "@type": "SoftwareApplication",
  "name": "Beatview Work Style Assessment",
  "applicationCategory": "BusinessApplication",
  "operatingSystem": "Web",
  "url": "https://beatview.ai/work-style-assessment",
  "description": "Structured work style assessment for understanding candidate collaboration preferences and team fit.",
  "featureList": [
    "Collaboration preference insights",
    "Communication style analysis",
    "Adaptability indicators",
    "Structure preference mapping",
    "Visual dimension reports"
  ],
  "offers": {
    "@type": "Offer",
    "price": "0",
    "priceCurrency": "USD"
  },
  "creator": {
    "@type": "Organization",
    "name": "Beatview",
    "url": "https://beatview.ai"
  },
  "softwareHelp": {
    "@type": "WebPage",
    "url": "https://platform.beatview.ai/docs"
  }
};

export function WorkStyleAssessmentStructuredData() {
  return <StructuredData data={[webPageSchema, breadcrumbSchema, softwareApplicationSchema]} />;
}
